//import BREAKPOINTS from './config/breakpoints';
const BREAKPOINTS = {
	BASE: {
		LABEL: 'base',
		VALUE: 1,
	},
	SMALL: {
		LABEL: 'small',
		VALUE: 480,
	},
	MEDIUM: {
		LABEL: 'medium',
		VALUE: 769,
	},
	LARGE: {
		LABEL: 'large',
		VALUE: 960,
	},
	XLARGE: {
		LABEL: 'xlarge',
		VALUE: 1200,
	},
	MAX: {
		LABEL: 'max',
		VALUE: 1920,
	},
};

const SELECTORS = {
	PRODUCT_HANDLE: '[data-product-handle]',
	ACCORDION: '.accordion--pdp',
	ACCORDION_TRIGGER: '.accordion__trigger',
	ACCORDION_ITEM: {
		FEATURES: '#Features',
		SPECS: '#Specs',
		REGISTER_WARRANTY: '#Register_Warranty',
		SUPPORT: '#Support',
		REVIEWS: '#Reviews',
		PARTS: '#Parts',
	},
	REGISTER_PRODUCT: '.js-register-product',
	PARTS_CAROUSEL: '.js-parts-carousel',
	RELATED_PRODUCTS_CAROUSEL: '.js-related-products-carousel'
}

const pdpAccordion = document.querySelector(SELECTORS.ACCORDION);
const registerProductLink = document.querySelector(SELECTORS.REGISTER_PRODUCT);
const relatedProducts = document.querySelector(SELECTORS.RELATED_PRODUCTS_CAROUSEL);
const isLargeBreakpoint = window.matchMedia(`(min-width: ${BREAKPOINTS.LARGE.VALUE}px)`);

const pdpInit = () => {
	if (window.location.hash) {
		openTab();
	} else {
		openFirstTabOnDesktop();
	}

	isLargeBreakpoint.addListener(handleLargeBreakpoint);

	if (relatedProducts) {
		addRelatedProductsCarousel();
	}

	if (registerProductLink) {
		registerProductLink.addEventListener('click', handleRegisterProductLinkClick);
	}

	window.addEventListener("hashchange", openTab, false);
}

const openFirstTabOnDesktop = () => {
	if (isLargeBreakpoint.matches) {
		clickFirstTab();
	}
}

const openTab = () => {
	let tabToOpen;

	switch (window.location.hash) {
		case '#features':
			tabToOpen = SELECTORS.ACCORDION_ITEM.FEATURES;
			break;
		case '#specs':
			tabToOpen = SELECTORS.ACCORDION_ITEM.SPECS;
			break;
		case '#register':
			tabToOpen = SELECTORS.ACCORDION_ITEM.REGISTER_WARRANTY;
			break;
		case '#support':
			tabToOpen = SELECTORS.ACCORDION_ITEM.SUPPORT;
			break;
		case '#reviews':
			tabToOpen = SELECTORS.ACCORDION_ITEM.REVIEWS;
			break;
		case '#parts':
			tabToOpen = SELECTORS.ACCORDION_ITEM.PARTS;
			break;
		default:
			openFirstTabOnDesktop();
			return false;
			break;
	}

	let buttonToClick = document.querySelector(`${tabToOpen} button`);

	if (buttonToClick) {
		pdpAccordion.scrollIntoView({behavior: 'smooth'});
		buttonToClick.click();
	} else {
		openFirstTabOnDesktop();
	}
}

const handleRegisterProductLinkClick = event => {
	event.preventDefault();

	let registerButton = document.querySelector(`${SELECTORS.ACCORDION_ITEM.REGISTER_WARRANTY} button`);

	pdpAccordion.scrollIntoView({behavior: 'smooth'});

	if (registerButton.dataset.current !== 'true') {
		registerButton.click();
	}
}

const handleLargeBreakpoint = () => {
	setTabMultiAttribute();
}

const addRelatedProductsCarousel = () => {
	$(SELECTORS.RELATED_PRODUCTS_CAROUSEL).slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: theme.bp.medium,
				settings: {
					slidesToShow: 2,
					arrows: false,
					dots: true
				}
			},
			{
				breakpoint: theme.bp.widescreen,
				settings: {
					slidesToShow: 4,
					arrows: false,
					dots: true
				}
			}
		]
	});
}

// the accordion/tab structure only opens multiple tabs for smaller devices.
// Desktop must maintain one tab open at a time
const setTabMultiAttribute = () => {
	if (isLargeBreakpoint.matches) {
		pdpAccordion.removeAttribute('data-multi');

		// make sure all tabs are closed if resizing the window
		document.querySelectorAll(SELECTORS.ACCORDION_TRIGGER).forEach(trigger => {
			trigger.setAttribute('data-current', 'false');
			trigger.setAttribute('aria-expanded', 'false');
		});

		// then click on the first tab
		clickFirstTab();
	} else {
		pdpAccordion.setAttribute('data-multi', 'true');
	}
}

const clickFirstTab = () => {
	let firstTabButton = document.querySelector(SELECTORS.ACCORDION_TRIGGER);

	if (firstTabButton.dataset.current !== 'true') {
		firstTabButton.click();
	}
}

pdpInit();